const wildcardWrapper = document.querySelectorAll(`.wildcards-wrapper`);

if (wildcardWrapper) {
  wildcardWrapper.forEach((wildcard) => {
    const wildcards = wildcard.querySelectorAll(`.wildcard-container`);
    const wildcardItems = wildcards.length;
    let currentSlide = 0;

    function setInitialClasses() {
      /**
       * Handles whether or not there are two or
       * less wildcards being rendered. If so, only
       * set active and next classes.
       */
      if (wildcardItems <= 2) {
        wildcards[0].classList.add(`active`);
        wildcards[1].classList.add(`next`);
      } else {
        wildcards[wildcardItems - 1].classList.add(`prev`);
        wildcards[0].classList.add(`active`);
        wildcards[1].classList.add(`next`);
      }
    }

    function moveSlide(n) {
      let resetWildcards = wildcards;
      /**
       * Remove all classes from the wildcard containers
       * and apply freash 'wildcard-container' class.
       */
      for (i = 0; i < resetWildcards.length; i++) {
        resetWildcards[i].className = ``;
        resetWildcards[i].className = `wildcard-container`;
      }

      currentSlide = (n + wildcards.length) % wildcards.length;

      /**
       * If the remainder of the current slider count
       * is 0 reset all the classes back to original state.
       */
      if (currentSlide === 0) {
        setInitialClasses();
      } else if (resetWildcards.length === 2) {
        /**
         * If there are only two wildcards, only active
         * and prev will be applied when clicking the
         * next or prev button.
         */
        prevSlide = (currentSlide - 1) % wildcards.length;
        wildcards[currentSlide].className = `wildcard-container active`;
        wildcards[prevSlide].className = `wildcard-container next`;
      } else {
        prevSlide = (currentSlide - 1) % wildcards.length;
        nextSlide = (currentSlide + 1) % wildcards.length;
        wildcards[currentSlide].className = `wildcard-container active`;
        wildcards[prevSlide].className = `wildcard-container prev`;
        wildcards[nextSlide].className = `wildcard-container next`;
      }
    }

    function moveNext() {
      moveSlide(currentSlide + 1);
    }

    function movePrev() {
      moveSlide(currentSlide - 1);
    }

    function initCarousel() {
      setInitialClasses();
    }

    if (wildcardWrapper && wildcardItems > 1) {
      initCarousel();

      let next = wildcard.querySelector(`.right-arrow`);
      next.addEventListener(`click`, moveNext);

      let prev = wildcard.querySelector(`.left-arrow`);
      prev.addEventListener(`click`, movePrev);
    }
  });
}
